import { render } from "./ImportSentenceDialog.vue?vue&type=template&id=86ce3c52&scoped=true"
import script from "./ImportSentenceDialog.vue?vue&type=script&lang=js"
export * from "./ImportSentenceDialog.vue?vue&type=script&lang=js"

import "./ImportSentenceDialog.vue?vue&type=style&index=0&id=86ce3c52&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86ce3c52"]])

export default __exports__